import { User } from '../models/user.interface';

/**
 * Utenti Google (o legacy) che devono ancora confermare nome, cognome e newsletter.
 */
export function userNeedsProfileCompletion(user: User | null | undefined): boolean {
  if (!user) {
    return false;
  }
  if (user.profileCompletionPending === true) {
    return true;
  }
  const name = user.name?.trim() ?? '';
  const surname = user.surname?.trim() ?? '';
  if (!name || !surname) {
    return true;
  }
  if (name === 'Utente' && surname === 'Google') {
    return true;
  }
  return false;
}
